import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Menu, X, ChevronRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

const LINKS = [
  { label: "CRE", to: "/cre" },
  { label: "Capital", to: "/capital" },
  { label: "Media", to: "/media" },
  { label: "Private Network", to: "/private-network" },
  { label: "Michael Brown", to: "/michael-brown" },
  { label: "Aspire", to: "/aspire" },
];

export default function Navbar() {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-[#0A0A0A]/90 backdrop-blur-xl border-b border-white/10" : "bg-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" className="font-display text-xl font-extrabold tracking-tight" data-testid="logo-link">
          MOAGLEE<span className="text-[#CC5500]">.</span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="text-sm text-neutral-300 hover:text-white transition-colors"
              data-testid={`nav-${l.to.replace("/", "")}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          {user ? (
            <Link to={user.role === "admin" ? "/admin" : "/dashboard"} className="btn-ghost text-sm py-2 px-4" data-testid="nav-dashboard-btn">
              {user.role === "admin" ? "Admin" : "Dashboard"}
            </Link>
          ) : (
            <Link to="/login" className="text-sm text-neutral-300 hover:text-white transition-colors" data-testid="nav-login-btn">
              Member Login
            </Link>
          )}
          <button onClick={() => navigate("/book-call")} className="btn-primary text-sm py-2 px-4" data-testid="nav-book-call-btn">
            Book a Call <ChevronRight size={16} />
          </button>
        </div>

        <button className="lg:hidden text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-btn">
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden bg-[#0A0A0A] border-t border-white/10 px-6 py-6 flex flex-col gap-4" data-testid="mobile-menu">
          {LINKS.map((l) => (
            <Link key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-neutral-200 py-1">
              {l.label}
            </Link>
          ))}
          <Link to={user ? (user.role === "admin" ? "/admin" : "/dashboard") : "/login"} onClick={() => setOpen(false)} className="text-neutral-200 py-1">
            {user ? "Dashboard" : "Member Login"}
          </Link>
          <button onClick={() => { setOpen(false); navigate("/book-call"); }} className="btn-primary justify-center mt-2">
            Book a Strategy Call
          </button>
        </div>
      )}
    </header>
  );
}
